export default "__VITE_ASSET__DhdQe7pC__"